//==============================
// Hero
//==============================

$('.home-hero-scroll').click(function() {
  var heroScroll = $(this);
  var nextElement = heroScroll.parent('.home-hero').next().offset().top;
  $('html, body').animate({ scrollTop: nextElement - 10 }, 800);
  return false;
});
